import styled from "@emotion/styled"
import { motion, AnimatePresence } from "framer-motion"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"

import { useValue } from "./context"
import EditoFilterItem from "./EditoFilterItem"
import EditoRoller from "./EditoRoller"

const Container = styled.div`
  grid-column: 1 / -1;
`

const FiltersContainer = styled.div`
  width: calc(100% - var(--outer-margin) * 2);
  overflow-x: auto;
  padding-inline: var(--outer-margin);
  mask-image: linear-gradient(90deg, rgb(0 0 0 / 1), rgb(0 0 0 / 1) 90%, rgb(0 0 0 / 0.2) 100%);

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  // to prevent fieldset focus outline to be cut :
  padding-block-start: 10px;
  margin-block-start: -10px;
  //////////////////////////////////////////////
`

const Filters = styled.fieldset`
  margin: 0 auto;
  display: grid;
  grid-auto-flow: column;
  width: fit-content;
  border: none;

  padding: 0;

  margin-block-end: 16px;

  ${getMediaQuery("m")} {
    margin-block-end: 24px;
  }

  &:has(.focus-visible) {
    outline: 2px solid rgb(var(--focus, 0 255 255) / 1) !important;
    outline-offset: 3px !important;
  }

  padding-inline: 20px;
`

const RollerContainer = styled.nav`
  display: grid;
  grid-template-rows: 1fr;
`

const Rollainer = styled(motion.div)`
  grid-row: 1;
  grid-column: 1;
  display: grid;
`

function FiltersGroup({ tabs }) {
  return (
    <FiltersContainer>
      <Filters>
        {tabs.map((t, i) => (
          <EditoFilterItem key={`filter-item-${t.label}`} index={i} {...t} tabNumber={tabs.length} />
        ))}
      </Filters>
    </FiltersContainer>
  )
}

export default function EditoFilters({ tabs }) {
  const console = useConsole()
  const { currentIndex } = useValue()

  return (
    <Container>
      {tabs.length > 1 ? <FiltersGroup tabs={tabs} /> : null}
      <RollerContainer aria-labelledby={tabs.length > 1 ? tabs[currentIndex]._metadata.uid : null} aria-label={tabs[currentIndex].label}>
        {tabs.map((t, i) => (
          <AnimatePresence mode='wait' key={`roller-${t.label}`}>
            {currentIndex === i && (
              <Rollainer key='roller-container' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                <EditoRoller {...t} />
              </Rollainer>
            )}
          </AnimatePresence>
        ))}
      </RollerContainer>
    </Container>
  )
}
